import { defineMessages } from 'react-intl';
export default defineMessages({
    accountOnHold: {
        id: 'addons.accountOnHold',
        defaultMessage: 'Your account connection has expired. Please reconnect to resume data updates.'
    },
    accountOnHoldTitle: {
        id: 'addons.accountOnHoldTitle',
        defaultMessage: 'Account on hold'
    },
    ambientWeatherCreateAndRetrieveApiKey: {
        id: 'addons.ambientWeatherCreateAndRetrieveApiKey',
        defaultMessage: 'Create and retrieve your API key from this link'
    },
    ambientWeatherDescription: {
        id: 'addons.ambientWeatherDescription',
        defaultMessage: 'Ambient Weather stations (WS-5000, WS-2000, WS-2902C,...)'
    },
    apiKey: {
        id: 'addons.apiKey',
        defaultMessage: 'API key'
    },
    applicationKey: {
        id: 'addons.applicationKey',
        defaultMessage: 'Application key'
    },
    availableServices: {
        id: 'addons.availableServices',
        defaultMessage: 'Available'
    },
    cannotDisconnectLastAccount: {
        id: 'addons.cannotDisconnectLastAccount',
        defaultMessage: 'Cannot disconnect your only login method. Please add another login method first.'
    },
    connect: {
        id: 'addons.connect',
        defaultMessage: 'Connect'
    },
    connected: {
        id: 'addons.connected',
        defaultMessage: 'Connected'
    },
    connectedAccounts: {
        id: 'addons.connectedAccounts',
        defaultMessage: 'Connected Accounts'
    },
    connectedAccountsDescription: {
        id: 'addons.connectedAccountsDescription',
        defaultMessage: 'Apple, Google, Facebook'
    },
    connectedServices: {
        id: 'addons.connectedServices',
        defaultMessage: 'Connected'
    },
    connectedSince: {
        id: 'addons.connectedSince',
        defaultMessage: 'Connected since {date}'
    },
    connectionSection: {
        id: 'addons.connectionSection',
        defaultMessage: 'Connection'
    },
    connectionSuccess: {
        id: 'addons.connectionSuccess',
        defaultMessage: '{provider} account connected successfully'
    },
    davisApiSecret: {
        id: 'addons.davisApiSecret',
        defaultMessage: 'API Secret'
    },
    davisApiV2Key: {
        id: 'addons.davisApiV2Key',
        defaultMessage: 'V2 API Key'
    },
    davisDescription: {
        id: 'addons.davisDescription',
        defaultMessage: 'Davis weather stations (Vantage Vue, Vantage Pro2,...)'
    },
    davisRetrieveApiKey: {
        id: 'addons.davisRetrieveApiKey',
        defaultMessage: 'Retrieve your V2 API keys from this link'
    },
    disconnect: {
        id: 'addons.disconnect',
        defaultMessage: 'Disconnect'
    },
    disconnectConfirmation: {
        id: 'addons.disconnectConfirmation',
        defaultMessage: 'Are you sure you want to disconnect your {provider} account?'
    },
    disconnectionSuccess: {
        id: 'addons.disconnectionSuccess',
        defaultMessage: '{provider} account disconnected successfully'
    },
    disconnectProviderDescription: {
        id: 'addons.disconnectProviderDescription',
        defaultMessage: 'Stops syncing. Your history is kept.'
    },
    ecowittCreateAndRetrieveKeys: {
        id: 'addons.ecowittCreateAndRetrieveKeys',
        defaultMessage: 'Create and retrieve both an API key and an application key from this link'
    },
    ecowittDescription: {
        id: 'addons.ecowittDescription',
        defaultMessage: 'Ecowitt provides professional wifi weather station, wireless indoor outdoor thermometers, humidity monitors, high precision rain gauges, air quality monitors and more.'
    },
    helpLink: {
        id: 'addons.helpLink',
        defaultMessage: 'How to connect {provider}'
    },
    integrationsSection: {
        id: 'addons.integrationsSection',
        defaultMessage: 'Integrations'
    },
    myAcuriteAccountOnHold: {
        id: 'addons.myAcuriteAccountOnHold',
        defaultMessage: 'Your account has been placed on hold. Please enter your password to reconnect your account'
    },
    myAcuriteDescription: {
        id: 'addons.myAcuriteDescription',
        defaultMessage: 'AcuRite is the #1 weather station brand in North America. As a leader in time, temperature, and weather technology, AcuRite provides you with detailed information about your indoor and outdoor environment so you can plan your day with confidence.'
    },
    netatmoEnergy: {
        id: 'addons.netatmoEnergy',
        defaultMessage: 'Netatmo Energy'
    },
    netatmoEnergyDescription: {
        id: 'addons.netatmoEnergyDescription',
        defaultMessage: "Use your Netatmo Thermostat to change your home's temperature, from your bed or from the other side of the world."
    },
    netatmoWeather: {
        id: 'addons.netatmoWeather',
        defaultMessage: 'Netatmo Weather'
    },
    netatmoWeatherDescription: {
        id: 'addons.netatmoWeatherDescription',
        defaultMessage: 'Your personal weather station at home'
    },
    notConnected: {
        id: 'addons.notConnected',
        defaultMessage: 'Not connected'
    },
    or: {
        id: 'addons.or',
        defaultMessage: 'or'
    },
    providerAccountDisconnected: {
        id: 'addons.providerAccountDisconnected',
        defaultMessage: 'The connection to your weather service has expired. Please reconnect to resume data updates.'
    },
    reconnect: {
        id: 'addons.reconnect',
        defaultMessage: 'Reconnect'
    },
    socialConnectionsIntro: {
        id: 'addons.socialConnectionsIntro',
        defaultMessage: 'Link your social accounts to enable quick sign-in. You can connect or disconnect accounts at any time.'
    },
    weatherflowCreateToken: {
        id: 'addons.weatherflowCreateToken',
        defaultMessage: 'Create and retrieve your token from this link'
    },
    weatherflowTempestDescription: {
        id: 'addons.weatherflowTempestDescription',
        defaultMessage: 'Tempest Weather System with Built-in Wind Meter, Rain Gauge'
    },
    weatherServices: {
        id: 'addons.weatherServices',
        defaultMessage: 'Weather Services'
    },
    weatherServicesConnected: {
        id: 'addons.weatherServicesConnected',
        defaultMessage: '{count, plural, =0 {No services connected} one {# service connected} other {# services connected}}'
    },
    weatherServicesDescription: {
        id: 'addons.weatherServicesDescription',
        defaultMessage: 'Connect Netatmo, Davis, Weatherflow, and more'
    },
    wundergroundApiKey: {
        id: 'addons.wundergroundApiKey',
        defaultMessage: 'API key'
    },
    wundergroundDescription: {
        id: 'addons.wundergroundDescription',
        defaultMessage: 'Weather Underground is a global community of people connecting data from environmental sensors like weather stations and air quality monitors so we can provide the rich, hyperlocal data you need to power your passions'
    },
    wundergroundRetrieveApiKey: {
        id: 'addons.wundergroundRetrieveApiKey',
        defaultMessage: 'Retrieve your API key from this link'
    },
    wundergroundStationId: {
        id: 'addons.wundergroundStationId',
        defaultMessage: 'Station ID'
    }
});
